import { Card, Descriptions, Pagination, Popover, Spin, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react'
import { useMediaQuery } from 'react-responsive';

const ViolationListView = ({ violationData, loading, pagination, setPagination }) => {

    const dataSource = violationData;
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const columns = [
        {
            title: "Team",
            dataIndex: "team",
            key: "team",
            onCell: () => ({ style: { verticalAlign: 'top' } }),
            render: (text, record) => (
                <>
                    <Tag color="blue">{text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}</Tag>
                    <br />
                    <div>
                        {moment(record.created_at).local().format("DD-MM-YYYY hh:mm A")}
                    </div>
                </>
            )
        },
        {
            title: "Violation Type",
            dataIndex: "violation_type",
            key: "violation_type",
            onCell: () => ({ style: { verticalAlign: 'top' } }),
            render: (text) => {
                const formattedText = text.split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
                return (
                    <div>
                        <Tag color="blue">{formattedText}</Tag>
                    </div>
                );
            }
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            width: 200,
            onCell: () => ({ style: { verticalAlign: 'top' } })
        },
        {
            title: "Additional Info",
            dataIndex: "additional_info",
            key: "additional_info",
            width: 200,
            onCell: () => ({ style: { verticalAlign: 'top' } })
        },
        {
            title: "Evidence File",
            dataIndex: "evidence_files",
            key: "evidence_files",
            onCell: () => ({ style: { verticalAlign: 'top' } }),
            render: (evidence) => {
                const fileList = Array.isArray(evidence)
                    ? evidence
                    : typeof evidence === 'string'
                        ? evidence.split(',').map(s => s.trim())
                        : [];

                return (
                    <Popover
                        title="Evidence Files"
                        trigger="click"
                        content={
                            <div style={{ margin: 0 }}>
                                {fileList.map((file, index) => (
                                    <div key={index}>
                                        <a href={file} target="_blank" rel="noopener noreferrer">
                                            File {index + 1}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        }
                    >
                        {fileList.length > 0 ? <a style={{ cursor: 'pointer' }}>View</a> : <span>No files</span>}
                    </Popover>
                );
            },
        }

    ];

    if (loading) {
        return <Spin className="flex justify-center items-center w-full my-6" size="large" />;
    }
    return (
        <div>

            {isMobile ? (
                <div style={{ padding: 0, margin: 0 }}>
                    {dataSource.map((item) => (
                        <Card
                            key={item.id}
                            bodyStyle={{ padding: 0, marginBottom: 16 }}
                            style={{ margin: 0, border: 'none', borderBottom: '1px solid #f0f0f0' }}
                        >
                            <Descriptions column={1} size="small" bordered style={{ margin: 0 }}>
                                <Descriptions.Item label="Teams">{item.team.charAt(0).toUpperCase() + item.team.slice(1).toLowerCase()}</Descriptions.Item>
                                <Descriptions.Item label="Violation Type">
                                    {item.violation_type
                                        .split('_')
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                        .join(' ')
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item label="Description">{item.description}</Descriptions.Item>
                                <Descriptions.Item label="Created At">{moment(item.created_at).local().format("DD-MM-YYYY hh:mm A")}</Descriptions.Item>
                                <Descriptions.Item label="Evidence File">
                                    {item?.evidence_files?.length > 0 ? (
                                        <Popover
                                            title="Evidence Files"
                                            trigger="click"
                                            content={
                                                <div style={{ margin: 0 }}>
                                                    {item?.evidence_files?.map((file, index) => (
                                                        <div key={index}>
                                                            <a href={file} target="_blank" rel="noopener noreferrer">
                                                                File {index + 1}
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        >
                                            <a style={{ cursor: 'pointer' }}>View</a>
                                        </Popover>
                                    ) : (
                                        <span>No files</span>
                                    )}
                                </Descriptions.Item>

                            </Descriptions>
                        </Card>
                    ))}
                    <div style={{ textAlign: "center", marginTop: 16 }}>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            onChange={(page) => setPagination((prev) => ({ ...prev, current: page }))}
                            showSizeChanger={false}
                        />
                    </div>
                </div>
            ) : (
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: (page, pageSize) => {
                            setPagination({ ...pagination, current: page, pageSize });
                        },
                        onShowSizeChange: (current, size) => {
                            setPagination({ ...pagination, current: 1, pageSize: size });
                        },
                    }}
                    rowKey={(record) => record.id}
                    bordered
                    scroll={{ x: 'max-content' }}
                    className="violation-table"
                />
            )}

        </div>
    )
}

export default ViolationListView